import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

export const DATE_COLUMN_INDENT = 12;
export const DATE_COLUMN_WIDTH = 88;
export const HEADER_ROW_HEIGHT = 87;
export const COLUMN_WIDTH = 44;
export const COLUMN_HEIGHT = 36;

export const DATE_FORMAT_KEY = 'DD-MM-YYYY';

export const ABSENCE_COLORS_TO_TONES_RELATIONS: { [key: string]: any } = Object.entries(
  PLATFORM_THEME_COLORS.allowedColorsToUse
).reduce(
  (memo, [, { normal, light }]) => ({
    ...memo,
    [normal]: light,
  }),
  {}
);
